import * as React from 'react';
import { useFormContext } from 'react-hook-form';
import { EditMode } from '../../../../data/enums';
import { Grid, IconButton, TextField } from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';

interface IManifestItemProps {
  fieldsArrayKey: string;
  fieldIndex: number;
  mode: EditMode;
  remove: (index?: number | number[]) => void;
}

export default function ManifestItem (props: IManifestItemProps) {

  const { register, getValues, getFieldState } = useFormContext();

  const deleteHandler = (index: number) => {
    const count = getValues(props.fieldsArrayKey).length;
    if (count <= 1) return;
    props.remove(index);
  };

  const isError = (fieldName: string) : boolean => {
    // https://stackoverflow.com/questions/66215601/react-hook-forms-how-to-pass-the-errors-as-a-props-using-typescript
    // https://github.com/react-hook-form/react-hook-form/issues/7381
    const error = getFieldState(`${props.fieldsArrayKey}.${props.fieldIndex}.${fieldName}`).error;
    return Boolean(error);
  };

  const getErrorMessage = (fieldName: string) : string => {
    const error = getFieldState(`${props.fieldsArrayKey}.${props.fieldIndex}.${fieldName}`).error;
    if (error?.message) return error.message;
    return '';
  };

  return (
    <Grid 
      container 
      spacing={2}
      mb={2}>

      <Grid item xs={3} >
        
        {/* Category */}
        <TextField 
          fullWidth
          label='File label'
          type='text'
          error={isError('Category')}
          helperText={getErrorMessage('Category')}
          {...register(
            `${props.fieldsArrayKey}.${props.fieldIndex}.Category` as const, 
            { required: 'File label is required!',
              validate: {
                noSpaces: value => !/\s/.test(value) || 'Spaces are not allowed!'
              }
           })
          } />
      </Grid>
      <Grid item xs={8}>

        {/* PII string */}
        <TextField 
          fullWidth
          label='File attributes PII list'
          type='text'
          error={isError('PiiAttributes')}
          helperText={getErrorMessage('PiiAttributes')}
          {...register(
            `${props.fieldsArrayKey}.${props.fieldIndex}.PiiAttributes` as const, 
            {
              pattern: 
                {
                  value: /^(?:\s*[a-z][a-z0-9_]*(?:\s*,\s*[a-z][a-z0-9_]*)*(?:\s*,\s*)?\s*)?$/,
                  message: 'Must be comma separated list of attribute names (column headers). Headers should be all lowercase and spaces replaced with underscores.' 
                }
            })
          } />

      </Grid>
      <Grid item xs={1}>

        {/* Delete button */}
        <IconButton 
          aria-label="delete manifest item"
          onClick={() => deleteHandler(props.fieldIndex)}>
          <DeleteIcon />
        </IconButton>

      </Grid>
    </Grid>
  );
}